module.exports = __webpack_public_path__ + "8bc3ea94539adac99d32c642e435fdd6.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/referral/stripe.svg
// module id = 1016
// module chunks = 0